import { Alert, Button, Flex, Typography } from 'antd';
import { useNavigate, useParams } from 'react-router';

import { CREDIT_ACCOUNT_VIEWS } from 'utilities/constants';
import { creditAccountPath } from 'utilities/routes';

const { Title } = Typography;

const StepContainer = ({
  children,
  buttonProps = {},
  buttonText = 'Continue',
  justifyContinueButton,
  information = '',
  errorMessage = '',
  onContinue,
  onExit,
  title = '',
  ...rest
}) => {
  const { accountId, customerId } = useParams();
  const navigate = useNavigate();

  const exitFlow = () => {
    onExit();
    navigate(
      creditAccountPath(
        customerId,
        accountId,
        CREDIT_ACCOUNT_VIEWS.CARD_DETAILS,
      ),
    );
  };

  return (
    <Flex vertical={true} {...rest}>
      {title ? (
        <Title
          data-testid="step-title"
          level={5}
          style={{ marginBottom: 'var(--spacing)' }}
        >
          {title}
        </Title>
      ) : null}

      {information ? (
        <Alert
          banner
          data-testid="step-info"
          type="info"
          title={information}
          style={{ marginBottom: 'var(--spacing)' }}
        ></Alert>
      ) : null}

      <div style={{ marginBottom: 'var(--spacing)' }}>{children}</div>

      <div style={{ marginTop: 'auto' }}>
        {errorMessage && (
          <Alert
            banner
            data-testid="step-error"
            type="error"
            title={errorMessage}
            style={{ marginBottom: 'var(--spacing)' }}
          />
        )}
        <Flex
          gap={'var(--spacing)'}
          justify={justifyContinueButton ?? undefined}
        >
          {onContinue ? (
            <Button
              data-testid="step-continue-button"
              type="primary"
              onClick={onContinue}
              disabled={buttonProps.loading}
              {...buttonProps}
            >
              {buttonText}
            </Button>
          ) : null}
          {onExit ? (
            <Button
              danger
              data-testid="step-exit-button"
              disabled={buttonProps.loading}
              onClick={exitFlow}
            >
              Exit Process
            </Button>
          ) : null}
        </Flex>
      </div>
    </Flex>
  );
};

export default StepContainer;
